var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73D309",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.944 0C37.21 0 0 37.206 0 82.938c0 45.731 37.21 82.937 82.944 82.937 45.737 0 82.944-37.206 82.944-82.937C165.888 37.206 128.681 0 82.944 0zm0 152.279c-38.237 0-69.347-31.107-69.347-69.341 0-38.235 31.11-69.342 69.347-69.342 38.24 0 69.347 31.107 69.347 69.342 0 38.234-31.107 69.341-69.347 69.341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.192 56.35l-41.49 41.488-18.97-18.97a5.728 5.728 0 0 0-8.1 8.101l23.02 23.017a5.71 5.71 0 0 0 4.05 1.678c1.467 0 2.933-.56 4.051-1.678l45.541-45.537a5.729 5.729 0 0 0-8.102-8.099z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d9ae1ab7b272cb75bf491f65c5fae446.svg";
export { ForwardRef as ReactComponent };